<script setup lang="ts">
import { IonButton } from '@ionic/vue';
defineProps<{
  type?: 'button' | 'reset' | 'submit';
  disabled?: boolean;
}>();
</script>

<template>
  <ion-button class="transition-colors" expand="block" color="primary" :type="type" :disabled="disabled">
    <slot></slot>
  </ion-button>
</template>

<style scoped>
ion-button {
  --border-radius: 4px;
}
</style>
